import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, BookOpen } from 'lucide-react';

function TermsOfServicePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F8F5F0]">
      {/* Header */}
      <header className="bg-white border-b border-[#E0D8CC]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center space-x-3">
            <Button
              onClick={() => navigate(-1)}
              variant="ghost"
              className="text-[#2A2420]"
            >
              <ArrowLeft className="w-5 h-5" />
            </Button>
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-[#2A2420] rounded-lg flex items-center justify-center">
                <BookOpen className="w-4 h-4 text-white" />
              </div>
              <span className="font-semibold text-[#2A2420]">The Storyteller</span>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <div className="bg-white rounded-2xl p-8 shadow-sm border border-[#E0D8CC]">
          <h1 className="text-3xl font-serif font-bold text-[#2A2420] mb-2">Terms of Service</h1>
          <p className="text-gray-500 mb-8">Last updated: February 2025</p>

          <div className="prose prose-gray max-w-none">
            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 mb-4">
              By accessing or using The Storyteller, you agree to be bound by these Terms of Service. 
              If you don't agree to these terms, please don't use our service.
            </p>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">2. Your Account</h2>
            <p className="text-gray-700 mb-4">
              You're responsible for maintaining the security of your account. Use Google Sign-In 
              to access our service. Don't share your account with others.
            </p>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">3. Your Content</h2>
            <p className="text-gray-700 mb-4">
              You retain all ownership rights to the content you create on The Storyteller. By using 
              our service, you grant us a license to store, process, and display your content solely 
              to provide our services to you.
            </p>
            <p className="text-gray-700 mb-4">
              You're responsible for the content you create. Don't use our service to create content 
              that is illegal, harmful, or violates others' rights.
            </p>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">4. AI Features</h2>
            <p className="text-gray-700 mb-4">
              Our service uses AI to help you write and polish your content. AI suggestions are just 
              that - suggestions. The final content is your responsibility. AI outputs may occasionally 
              be inaccurate or inappropriate; please review all AI-generated content.
            </p>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">5. Free and Paid Plans</h2>
            <p className="text-gray-700 mb-4">
              We offer both free and paid subscription plans. Free plans have usage limits. Paid 
              subscriptions are billed monthly and can be canceled at any time. Refunds are handled 
              on a case-by-case basis.
            </p>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">6. Prohibited Uses</h2>
            <p className="text-gray-700 mb-4">
              You may not:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              <li>Use the service for any illegal purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Use automated tools to scrape or extract data</li>
              <li>Resell or redistribute our service without permission</li>
              <li>Create content that violates others' intellectual property</li>
            </ul>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">7. Service Availability</h2>
            <p className="text-gray-700 mb-4">
              We strive to keep our service available 24/7, but we don't guarantee uninterrupted 
              access. We may modify, suspend, or discontinue features with or without notice.
            </p>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700 mb-4">
              The Storyteller is provided "as is" without warranties of any kind. We're not liable 
              for any indirect, incidental, or consequential damages arising from your use of the service.
            </p>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">9. Changes to Terms</h2>
            <p className="text-gray-700 mb-4">
              We may update these terms from time to time. We'll notify you of significant changes. 
              Continued use of the service after changes constitutes acceptance of the new terms.
            </p>

            <h2 className="text-xl font-semibold text-[#2A2420] mt-8 mb-4">10. Contact</h2>
            <p className="text-gray-700 mb-4">
              Questions about these terms? Contact us through the feedback button in the app.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default TermsOfServicePage;
